/* src/app/shared/page-templates/page-with-splash/page-with-splash.component.scss */
/*# sourceMappingURL=page-with-splash.component-NGJWPQB7.css.map */
